import gn from "genart";

const pick = gn.math.randomElementFromArray;


export default class Config{
    static palettes = [   
        { name: "808 State",                background: "#f3f1ef", shadow: "#41321b", main: "#343030", accent:[ "#F3E0B1", "#F4CF67", "#F29D02", "#885C04","#B63023", "#EEDDC9", "#413B2E", "#232315" ]   },
        { name: "Black on White",           background: "#EEEEEE", shadow: "#666666", main: "#000000", accent:[ "#ffffff", "#999999","#aaaaaa" ]                                                                    }, 
        { name: "Bronze Rust",              background: "#3E725E", shadow: "#31624C", main: "#F2D2A2", accent: ["#F2A869", "#F28C6C", "#C44D58"] },
        { name: "C64",                      background: "#E0D3C3", shadow: "#59453C", main: "#59453C", accent:[ "#DE4E43", "#686A64" ],                                                                               },
        { name: "Chamonix",                 background: "#ABBCC1", shadow: "#0A2D47", main: "#1F475E", accent:[ "#CD5723","#D4702A","#D9D3B2", "#B1C5B9", "#5B7F94", "#6A95BF", "#21475E" ],                },
        { name: "Cheapzine",                background: "#FF5E5B", shadow: "#E74C49", main: "#2A363B", accent: ["#A8A7A7", "#5D8CAE", "#F8E3C4"] },
        { name: "Desert Storm",             background: "#E1DBC5", shadow: "#aea796", main: "#39261D", accent:[ "#d3671e", "#d6a561","#6c4847", "#faf9f1" ],                                                      }, 
        { name: "Emerald",                  background: "#261447", shadow: "#4ddbfb", main: "#4ddbfb", accent:[ "#ffffff", "#2e9808","#c1f601" ],                                                                   },
        { name: "Estraza",                  background: "#EBCB95", shadow: "#608671", main: "#2D3B33", accent:[ "#A8513E", "#B74F12","#FACF5A", "#FAE6B0", "#f3c19a", "#8FAA8C" ]                             },
        { name: "Fluor",                    background: "#e7e5e1", shadow: "#53554d", main: "#535a67", accent:[ "#c7ed1d", "#676666","#80b7d5" ],                                                                   }, 
        { name: "Forest Haze",              background: "#96A899", shadow: "#3B4D36", main: "#5D7864", accent: ["#C5D5BE", "#F6F9F4", "#214D28"] },
        { name: "Fresh Smile",              background: "#3A7C9E", shadow: "#1D3649", main: "#7EAAAD", accent: ["#C1D6D0", "#F1F5F3", "#539FA9"] },
        { name: "Gold Ink",                 background: "#4A90E2", shadow: "#3C79C6", main: "#F4E37A", accent: ["#F9C84A", "#F2764D", "#E74C3C"] },
        { name: "Graphite Error",           background: "#ebeced", shadow: "#212529", main: "#212529", accent:[ "#e33232" ],                                                                  },
        { name: "Grassy",                   background: "#7d9e75", shadow: "#282969", main: "#3C3350", accent:[ "#E9B32D", "#e4de9e","#5484cb" ],                                                                   },
        { name: "Kitty Claws",              background: "#77AED4", shadow: "#24518A", main: "#4E4C4D", accent:[ "#C9617C", "#F1D4B1","#FFFFFF" ],                                                                   },
        { name: "Massive Defense",          background: "#D49464", shadow: "#f6d8c1", main: "#3B3A3F", accent:[ "#C92F49", "#363739","#F8E4D9" ]                                                                    },        
        { name: "Mick",                     background: "#F8F8F8", shadow: "#ffffff", main: "#3D3D3D", accent:[ "#ED1D24", "#FECB00","#0089CF" ],                                                                   },
        { name: "Mistral",                  background: "#CECFC9", shadow: "#282969", main: "#5A4B76", accent:[ "#f9bbaf", "#4c9df4","#fbe44d", "#FDFDE0" ],                                                      },
        { name: "Moho",                     background: "#e9f1e9", shadow: "#686461", main: "#2c392c", accent:[ "#3a5c38", "#f7f5d0","#73827f" ],                                                                   }, 
        { name: "Monsieur M",               background: "#dedede", shadow: "#ffffff", main: "#000000", accent:[ "#CB2129", "#EBB72A","#242766" ],                                                                   },         
        { name: "Muddy Mark",               background: "#848883", shadow: "#22224c", main: "#3C3350", accent:[ "#E9B32D", "#e4de9e","#5484cb", "#65c065", "#c065bd" ],                                         },
        { name: "Optimus",                  background: "#DD2C4F", shadow: "#6a1829", main: "#323147", accent:[ "#ECBB31", "#f6f6f6","#363b94" ],                                                                   }, 
        { name: "Pool Tan",                 background: "#3498DB", shadow: "#2C81B8", main: "#ECF0F1", accent: ["#AED6F1", "#F5B041", "#E67E22"] },
        { name: "Purple Gold",              background: "#c78dc4", shadow: "#402869", main: "#3C3350", accent:[ "#eeb85a", "#F2ECEE","#95e8fb" ],                                                                   },
        { name: "Red District",             background: "#391447", shadow: "#f6013a", main: "#f60101", accent:[ "#fff4b5", "#f63601","#fbcd4d" ],                                                                   },        
        { name: "Sunglow",                  background: "#FF7A5E", shadow: "#B43C2A", main: "#F2A959", accent: ["#FFF6B1", "#EDF0EA", "#8A3D72"] },
        { name: "Synth Wave",               background: "#141847", shadow: "#F6019D", main: "#F6019D", accent:[ "#ffffff", "#f60157","#4ddbfb" ],                                                                   },
        { name: "TeeJay",                   background: "#faf9f6", shadow: "#D4D4D4", main: "#4E4E4E", accent:[ "#D3B1AF", "#B8D3E7","#FFA42D" ],                                                                   },
        { name: "Utopia",                   background: "#FDFBF7", shadow: "#2d1509", main: "#30464f", accent:[ "#122f28", "#2e4f4f","#ffab70" ],                                                                   }, 
        


      ];
      
    static paintModes = [
      { name:"Dotted", gradientChance:0, solidChance:0, offsetChance:1 },
      { name:"Gradient", gradientChance:1, solidChance:0, offsetChance:0 },
      { name:"Mixed", gradientChance:0.6, solidChance:0.4, offsetChance:0.3 },
      { name:"Outline", gradientChance:0, solidChance:0, offsetChance:0 },
      { name:"Solid", gradientChance:0, solidChance:1, offsetChance:0 },
    ];

    static colorDistribute = [
      { name:"Bottom Up", type:"linearGradient", startY:0.8 },
      { name:"Center Linear", type:"linearGradient", startY:0.5 },
      { name:"Center Radial", type:"radialGradient", startX:0.5, startY:0.5, endX:1, endY:1 },
      { name:"Random", type:"random" },
      { name:"Top Down", type:"linearGradient", startY:0.2 }
    ];

    static aperture = [        
        // Brooms
        { name: "60 ish", type:"random", min:55, max:65 }, 
        { name: "120", type:"pick", values:[120] }, 
        { name: "BreakIn", type:"by_level", values: [ 25,90,90,90 ] }, 
        { name: "BreakOut", type:"by_level", values: [ 90,90,90,25 ] }, 
        { name: "Brooms 1", type:"random", min:2, max:50 }, 
        { name: "Broom 2", type:"pick", values: [ 4,8,16,64 ] }, 
        { name: "Crystal Decay", type:"by_level", values: [ 120,100,90,60 ] }, 
        { name: "Crystal Fail", type:"by_level", values: [ 120,80,40,20 ] }, 
        { name: "Escherian", type:"pick", values: [72] }, 
        { name: "Iso Triangular", type:"pick", values: [ 60,60,60,120 ] }, 
        { name: "Square L1", type:"pick", values: [ 90,90,90,90 ] }, 
        { name: "Square L2", type:"pick", values: [ 90,90,90,45 ] }, 
        { name: "Square L3", type:"pick", values: [ 90,90,45,90 ] },         
      ];
      
      static concentration = [
        { name: "Top", type:"computed", num:(segment)=>{
            let distToFocal = Math.abs( pieceHeight*.05-segment.lineSegment.p1.y )
            return Math.min( Math.floor( gn.math.map( distToFocal, pieceHeight*.95, 0, 4, 7 ) ), 10 );
          }, 
          min:0, max:1 
        },
        { name: "Bottom", type:"computed", num:(segment)=>{
            let distToFocal = Math.abs( pieceHeight*.95-segment.lineSegment.p1.y )
            return Math.min( Math.floor( gn.math.map( distToFocal, pieceHeight*.95, 0, 4, 7 ) ), 10 );
          }, 
          min:0, max:1 
        },
        //{ name: "RandomByLevel", type:"random", num:(level)=>{return 8-2*level/* gn.math.randInt(10,2*level) */}, min:0, max:1 },
        { name: "Inner", type:"computed", num:(segment)=>{
            let distToFocal = gn.math.distance( segment.lineSegment.p1, {x:cX, y:cY});
            return Math.floor( gn.math.map( distToFocal, pieceHeight*.5,0,  4, 7 ) );
          }, 
          min:0, max:1 
        },
      
        { name: "Outer", type:"computed", num:(segment)=>{
            let distToFocal = gn.math.distance( segment.lineSegment.p1, {x:cX, y:cY});
            return Math.floor( gn.math.map( distToFocal, 0, pieceHeight*.5, 4, 7 ) );
            }, 
          min:0, max:1 
        },
       
        { name: "Random", type:"random", num:5, min:0, max:1 },
      ];

      static seedModes = [
        { name: "Grid Homo", seedLineWidth:1, type:"grid", 
            seedLength:500, rotation:pick([10,-10,60,-60]), marginX:300, marginY:300, numCols: 3, numRows: 3, offsetX:0, offsetY:0 , alternateRotation:gn.math.random()>.3 
        },
        { name: "Grid Lateral", seedLineWidth:1, type:"grid", 
            seedLength:200+gn.math.random()*2000, rotation:pick([-20,-10,10,20]), marginX:600, marginY:600, numCols: 5, numRows: 3, offsetX:0, offsetY:0 , alternateRotation:gn.math.random()>.3 
        },

        { name: "Grid Vertical", seedLineWidth:1, type:"grid", 
            seedLength:500, rotation:pick([10,-10,60,-60]), marginX:300, marginY:300, numCols: 4, numRows: 3, offsetX:0, offsetY:0 , alternateRotation:gn.math.random()>.3 
        },
        { name: "Longs", seedLineWidth:1, type:"grid", 
            seedLength:10000, rotation:gn.math.randomInRange(30,-30) , marginX:0, marginY:200, numCols: 1, numRows: gn.math.randInt(10,5), offsetX:0, offsetY:gn.math.randomInRange(600,-600), alternateRotation:gn.math.random()>.3 
        },
        { name: "Radial", seedLineWidth:1, type:"radial", 
            seedLength:800, numSeeds:12, innerRadius:3, outterRadius:1600, maxRadiusOffset:200, alternateRotation:gn.math.random()>1 
        },
        { name: "Random", seedLineWidth:1, type:"random", 
            seedLength:pick([100,300,400,500,600,800,1000,1200]), numSeeds:gn.math.randInt(8,6), minX:()=>200, minY:()=>200, maxX:()=>pieceWidth-200, maxY:()=>pieceHeight-200 
        },
        { name: "Shorts", seedLineWidth:1, type:"grid", 
            seedLength:200, rotation:gn.math.randomInRange(50,-50) , marginX:0, marginY:200, numCols: gn.math.randInt(5,3), numRows: gn.math.randInt(10,5), offsetX:0, offsetY:gn.math.randomInRange(600,-600), alternateRotation:gn.math.random()>.3 
        }


      ];

    constructor(options){
        this.style = new BaseStyle(options);
    }
}


class BaseStyle{
    constructor( options){

        // ---- GENERAL ----
        this.palette = options.palette

        // Constants
        this.line_maxThickness = 14
        this.tree_numLevels = 4

        // Line sketchiness

        this.tree_minBranches = 6
        this.tree_maxBranches = 12

        // ---- SEEDS ----
        this.seed_mode = options.seedMode;
        this.seed_length = options.seedMode.seedLength //pieceHeight*.5
        this.seed_numSeeds = options.seedMode.numSeeds || 1
        this.seed_marginX = options.seedMode.marginX//300
        this.seed_marginY = options.seedMode.marginY//300
        this.seed_numCols = options.seedMode.numCols//3
        this.seed_numRows = options.seedMode.numRows//1
        this.seed_offsetX = options.seedMode.offsetX//0
        this.seed_offsetY = options.seedMode.offsetY//0
        this.seed_rotation =  options.seedMode.rotation // degrees // Math.PI*.5
        this.seed_lineWidth = options.seedMode.seedLineWidth

        this.seed_innerRadius = options.seedMode.innerRadius
        this.seed_outterRadius = options.seedMode.outterRadius
        this.seed_maxRadiusOffset = options.seedMode.maxRadiusOffset

        
        // ---- BRANCHES ----
        this.branch_angles = options.aperture; //aperture[4] // pick( aperture )
        this.branch_positions = options.concentration; //pick( concentration )
        this.branch_length = pick([2500]);//pieceHeight*2
        
        // ---- EFFECTS ----
        this.fx_linesBlur = options.linesBlur
        this.fx_fillsBlur = options.fillsBlur

    }

    getSeeds(){
        let result = [];
        
        switch( this.seed_mode.type ){//
            case "grid":
                let rowStep = (pieceHeight-this.seed_marginY*2)/this.seed_numRows;
                let colStep = (pieceWidth-this.seed_marginX*2)/this.seed_numCols;
                let i = 0;
                for (let r = 0; r < this.seed_numRows; r++) {
                    for (let c = 0; c < this.seed_numCols; c++) {
                        let centerPoint = { 
                            x: this.seed_numCols==1 ? 
                                gn.math.map( 0.5, 0, 1, this.seed_marginX, pieceWidth-this.seed_marginX ) 
                                :
                                gn.math.map( c, 0, this.seed_numCols-1, this.seed_marginX, pieceWidth-this.seed_marginX ), 
                            y: this.seed_numRows==1 ?
                                gn.math.map( 0.5, 0, 1, this.seed_marginY, pieceHeight-this.seed_marginY )
                                :
                                gn.math.map( r, 0, this.seed_numRows-1, this.seed_marginY, pieceHeight-this.seed_marginY )
                        };
                        centerPoint.x += this.seed_offsetX
                        centerPoint.y += this.seed_offsetY
                        let p0 = gn.geom.rotatePoint( 
                          { x:centerPoint.x-this.seed_length*.5, y:centerPoint.y },  
                          centerPoint, 
                          gn.math.degToRad( this.seed_rotation )                            
                          );
                          let p1 = gn.geom.rotatePoint( 
                            { x:centerPoint.x+this.seed_length*.5, y:centerPoint.y },  
                            centerPoint, 
                            gn.math.degToRad( this.seed_rotation )
                            );
                        result.push( { p0, p1 } );
                        i++;
                    }
                }
                break;            
            
            case "random":
                let minX = this.seed_mode.minX();
                let minY = this.seed_mode.minY();
                let maxX = this.seed_mode.maxX();
                let maxY = this.seed_mode.maxY();
                for (let i = 0; i < this.seed_numSeeds; i++) {
                    let seed = { 
                        p0: gn.geom.randomPointInRectangle(minX, minY, maxX, maxY ),
                        p1: gn.geom.randomPointInRectangle(minX, minY, maxX, maxY ),
                    }
                    result.push( seed );
                }
                break;
            
            case "radial":
              let margin = 125 + this.seed_maxRadiusOffset;
                let centerPoint = { 
                  x: gn.math.randomInRange(pieceWidth-margin,margin), 
                  y: gn.math.randomInRange(pieceHeight-margin,margin) 
                };
                for (let i = 0; i < this.seed_numSeeds; i++) {
                  let radiusOffset = gn.math.randomInRange( this.seed_maxRadiusOffset, 0)
                    let angle = gn.math.degToRad( gn.math.map( i, 0, this.seed_numSeeds-1, 0, 360 ) );
                    let p0 = gn.geom.makePointAtAngleAndDistance( angle, this.seed_innerRadius+radiusOffset, centerPoint.x, centerPoint.y );
                    let p1 = gn.geom.makePointAtAngleAndDistance( angle, this.seed_outterRadius+radiusOffset, centerPoint.x, centerPoint.y );
                    let seed = { p0, p1 };
                    result.push( seed );
                }
                break;

        }
        return result;
    }
}